import { useEffect } from 'react';

/**
 * Assist-refresh bridge (#378) — a same-window nudge so a request raised from the
 * CommandBar "New request" button appears in the Coordination → Assist worklist
 * immediately, rather than waiting up to one 30s poll.
 *
 * "New request" (AssistanceControls, in the CommandBar) and the Assist worklist
 * (the Coordination tab, in the LeftRail) always live in the SAME window — the COP —
 * so a plain same-window CustomEvent is sufficient (no BroadcastChannel: the
 * operations-panel AssistQueueList polls on its own). Transient by design: this is
 * a "refetch now" signal, never stored state.
 */

export const ASSIST_CHANGED_EVENT = 'tsr:assist-changed';

/** Nudge every mounted Assist worklist in this window to refetch. */
export function requestAssistRefresh(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(ASSIST_CHANGED_EVENT));
  }
}

/** Run `onChange` whenever an assist request is created/changed in this window. */
export function useAssistRefresh(onChange: () => void): void {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    window.addEventListener(ASSIST_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(ASSIST_CHANGED_EVENT, onChange);
  }, [onChange]);
}
